export default __webpack_public_path__ + "assets/images/3929048fc4a60522bfc6256e4236b204.png";